// TrendToggle — the client's black joystick, as drawn: a grey-ringed black
// dish with the lever standing straight UP out of its centre (= ON) or
// pointing straight DOWN (= OFF). Same icon both ways — it FLIPS on the
// vertical axis (mirrored through the pivot), it does not swing round.
// `title` (optional) replaces the trend-line hover text — a sister custom
// uses the same joystick for other on/off switches.

export default function TrendToggle({ on, blocked, onToggle, label, size = 30, title: titleProp = null }) {
  const title = titleProp || (on ? `Trend line ON for ${label} — click to switch it off`
    : blocked ? 'Only two trend line toggles can be on at the same time — switch one off first'
      : `Trend line OFF for ${label} — click to switch it on`);
  return (
    <button type="button" onClick={blocked && !on ? undefined : onToggle} title={title} aria-pressed={on}
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', lineHeight: 0, display: 'inline-block' }}>
      <svg width={size} height={size * 1.5} viewBox="0 0 48 72" aria-hidden="true" style={{ display: 'block' }}>
        <defs>
          <linearGradient id="tj-lever" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#3a3a3d" /><stop offset="35%" stopColor="#1d1d1f" /><stop offset="100%" stopColor="#0f0f10" />
          </linearGradient>
          <linearGradient id="tj-gimbal" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#9a9a9e" /><stop offset="60%" stopColor="#6e6e72" /><stop offset="100%" stopColor="#4f4f53" />
          </linearGradient>
          <radialGradient id="tj-dish" cx="45%" cy="40%" r="65%">
            <stop offset="0%" stopColor="#3a3a3e" /><stop offset="100%" stopColor="#151517" />
          </radialGradient>
        </defs>
        {/* base: outer grey ring, inner ring, black dish, a highlight arc */}
        <circle cx="24" cy="36" r="17" fill="#6b6b6f" stroke="#111" strokeWidth="1.2" />
        <circle cx="24" cy="36" r="13.5" fill="#454549" />
        <circle cx="24" cy="36" r="11" fill="url(#tj-dish)" />
        <path d="M11.5 31 A13.5 13.5 0 0 1 17 24.5" fill="none" stroke="#bdbdc1" strokeWidth="1.4" strokeLinecap="round" opacity="0.8" />
        {/* the lever, pivoting at the dish centre: UP = on, DOWN = off */}
        <g style={{ transform: on ? 'scaleY(1)' : 'scaleY(-1)', transformOrigin: '24px 36px', transition: 'transform .3s cubic-bezier(.4,.1,.2,1)' }}>
          <rect x="19.5" y="20" width="9" height="20" rx="4.5" fill="url(#tj-gimbal)" stroke="#111" strokeWidth="0.8" />
          <line x1="22" y1="24" x2="22" y2="34" stroke="#d4d4d8" strokeWidth="1" strokeLinecap="round" opacity="0.9" />
          <path d="M16.5 4 h15 l1.8 21 h-18.6 z" fill="url(#tj-lever)" stroke="#0b0b0c" strokeWidth="1" strokeLinejoin="round" />
          <ellipse cx="24" cy="4" rx="7.5" ry="2.6" fill="#4a4a4e" stroke="#0b0b0c" strokeWidth="1" />
        </g>
      </svg>
    </button>
  );
}
